
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 72 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0073cf","d":"M0 0h72v36H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 12h72v12H0z"}}),_c('g',{attrs:{"id":"c","transform":"matrix(2 0 0 2 36 18)","fill":"#0073cf"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","transform":"rotate(18 3.157 -.5)","d":"M0 0v1h.5z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-144)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(10 -3.2)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(10 2.8)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(-10 -3.2)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(-10 2.8)"}})])
          )
        }
      }
    